import React from 'react';
import { Grid, Chip } from '@mui/material';
import Tile from 'components/Tile/Tile';
import { useWorkflowStyles } from './styles';
import { WorkflowEventType, workflowEventOptions } from './constants';

interface WorkflowNodeEventProps {
  selectedEvent: WorkflowEventType;
  onClick: () => void;
}

const WorkflowNodeEvent: React.FC<WorkflowNodeEventProps> = ({ selectedEvent, onClick }) => {
  const classes = useWorkflowStyles();

  const getEventLabel = () => {
    const option = workflowEventOptions.find(opt => opt.value === selectedEvent);
    return option?.label || selectedEvent;
  };

  return (
    <Grid item xs={8} className={classes.nodeContainer} onClick={onClick}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Tile className={classes.nodeTitle}>Event</Tile>
        </Grid>
        <Grid item xs={12}>
          <Chip label={getEventLabel()} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default WorkflowNodeEvent;
